import { Modal, Spinner } from "react-bootstrap";

function LoadingModal() {
    return (
        <Modal size="lg" centered show={true}>
            <Spinner animation="border" />
        </Modal>
    )
}

export default LoadingModal;

